module.exports = __webpack_public_path__ + "static/media/aragon80.75b58cbd.jpg";